import {ExchangePriceWithRelations, ProductWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";

export class OrderLine {

    public product: ProductWithRelations;
    public exchangePrice: ExchangePriceWithRelations
    public walletAddress: string;
    public walletNetwork: string;
    public walletMemo: string;
    public quantity: number;
    public quantityAfterFees: number;
    public totalToPayFor: number = 0;

    /**
     * If cryptoQuantityCanVary, the amount to pay for is inmutable but the amount of crypto can vary.
     * Otherwise, the oposite way: the amount of crypto is inmutable but the total to pay for can vary.
     */
    public cryptoQuantityCanVary: boolean;

    public status: number;

}

export enum OrderLineStatus {
    ERROR = 10001,
    PROCESSED = 1,
    CANCELLED = 5,
    REFUNDED = 6
}
